
const getObjectFromSlug = function (products,slug)
{
    let image = "";
    for (const key in products) {
        if (products.hasOwnProperty(key)) {
            const arr = products[key];
             image = arr.find( (ele) =>{ 
                if( ele.slug === slug )
                {
                    return ele;
                }
            } );
        }        
        if(image !== undefined)
        {
            return image;                  
        }
    }    
}

const getSiblingsFromSlug = function (products,slug_arr)
{
    let object = "";
    let final_ele_arr = [];
    for(const index in slug_arr){
        for (const key in products) {
            if (products.hasOwnProperty(key)) {
                const arr = products[key];
                object = arr.find( (ele) =>{
                    if( ele.slug === slug_arr[index] )
                    {
                        return ele;
                    }
                } );               
                if(object !== undefined)
                {                    
                    final_ele_arr.push(object)
                    break;             
                }
            }
        }
    }
    return final_ele_arr;            
}

export default { getObjectFromSlug, getSiblingsFromSlug  };